<div class="flex-1">
  <unite-header></unite-header>
  <mat-sidenav-container class="main-sidenav-container h-full w-full min-h-full min-w-full">
    <mat-sidenav class="main-sidenav" #sidenav="" mode="over" ngClass.gt-sm="has-border">
      <nav>
        <mat-list>
          <mat-divider></mat-divider>
          <a mat-list-item="" routerLink="/home" routerLinkActive="active" (click)="sidenav.close()">
            <span translate="">Home</span>
          </a>
          @if (!isProfessional) {
            <mat-divider></mat-divider>
            <a mat-list-item="" routerLink="/applications/start" routerLinkActive="active" (click)="sidenav.close()">
              <span translate="">Apply for financing</span>
            </a>
          }
          @if (isProfessional) {
            <mat-divider></mat-divider>
            <a mat-list-item="" routerLink="/customers" routerLinkActive="active" (click)="sidenav.close()">
              <span translate="">Clients</span>
            </a>
            <mat-divider></mat-divider>
            <a mat-list-item="" routerLink="/buildings" routerLinkActive="active" (click)="sidenav.close()">
              <span translate="">Buildings</span>
            </a>
          }
          <mat-divider></mat-divider>
          <a mat-list-item="" routerLink="/financings" routerLinkActive="active" (click)="sidenav.close()">
            <span translate="">Financings</span>
          </a>
          <mat-divider></mat-divider>
          <a mat-list-item="" routerLink="/applications" routerLinkActive="active" (click)="sidenav.close()">
            <span translate="">Applications</span>
          </a>
          @if (isProfessional) {
            <mat-divider></mat-divider>
            <a mat-list-item="" routerLink="/mortgages" routerLinkActive="active" (click)="sidenav.close()">
              <span translate="">Ongoing mortgages</span>
            </a>
            <mat-divider></mat-divider>
            <a mat-list-item="" routerLink="/tasks" routerLinkActive="active" (click)="sidenav.close()">
              <span translate="">Tasks</span>
            </a>
          }
          <mat-divider></mat-divider>
          <a mat-list-item="" routerLink="/reports" routerLinkActive="active" (click)="sidenav.close()">
            <span translate="">Reports</span>
          </a>
          <mat-divider></mat-divider>
        </mat-list>
      </nav>
    </mat-sidenav>
    <mat-sidenav #chatSidenav position="end" mode="side" class="chat-sidenav">
      <unite-chat-window (closeClicked)="chatSidenav.close()"></unite-chat-window>
    </mat-sidenav>
    <mat-sidenav-content class="main-sidenav-content">
      <div class="content">
        @if (loading === true) {
          <div class="loader loader-page">
            <mat-spinner diameter="32"></mat-spinner>
          </div>
        }
        @if (loading === false) {
          <router-outlet></router-outlet>
        }
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>

@if (!chatSidenav.opened) {
  <button mat-fab class="chat-fab" (click)="toggleChatSideNav()"
    [matTooltip]="(chatService.pendingRuns().length > 0 ? 'Documents for your attention' : 'Unite Assistant') | translate"
    [attr.aria-label]="'Unite Assistant' | translate"
    [matBadge]="chatService.pendingRuns().length" [matBadgeHidden]="chatService.pendingRuns().length === 0"
    matBadgeColor="warn" matBadgePosition="above before">
    <mat-icon>auto_awesome</mat-icon>
  </button>
}

@if (requestLoader === true) {
  <div class="request-loader">
    <mat-spinner diameter="32"></mat-spinner>
  </div>
}
